<template>
    <div class="full-wdith">
        <div
            v-for="(v, i) in list"
            :key="v.id"
            style="margin-bottom: 15px"
        >
            <UserRecordBackstage
                :obj="v"
                @clickBtn="clickBtnCallback"
            />
        </div>

        <div v-show="null == list || list.length == 0">
            <el-empty :description="i18n.tkey('lang_temporary_no_data')">

            </el-empty>
        </div>

    </div>
</template>

<script setup>

import UserRecordBackstage from "@/components/shopopee/backstage/user/userRecordBackstage.vue";
import {inject} from "vue";

const props = defineProps(["list"])
const emits = defineEmits(["clickBtn"])

const i18n = inject("i18n")

function clickBtnCallback(name, obj){
    emits("clickBtn", name, obj)
}

</script>

<style scoped>
    .full-wdith {
        width: 100%;
    }
</style>